import React from 'react'
import moment from 'moment'
import {Link, useParams} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {useFeedbackById} from '../../hooks/useFeedBack'

const FEEDBACK_LIST_PATH = '/apps/all-feedbacks/feedbacks'

const feedbackBreadcrumbs: Array<PageLink> = [
  {
    title: 'Feedbacks list',
    path: FEEDBACK_LIST_PATH,
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const FeedbackDetailsPage: React.FC = () => {
  const {id} = useParams()
  const {feedback, message, loading, error} = useFeedbackById(id)

  return (
    <>
      <PageTitle breadcrumbs={feedbackBreadcrumbs}>Feedback details</PageTitle>

      <div className='card'>
        <div className='card-header border-0 pt-6'>
          <div className='card-title m-0'>
            <h3 className='fw-bold m-0'>Feedback details</h3>
          </div>
          <div className='card-toolbar'>
            <Link to={FEEDBACK_LIST_PATH} className='btn btn-sm btn-light'>
              Back to feedbacks
            </Link>
          </div>
        </div>

        <div className='card-body pt-0'>
          {loading && <div className='text-center text-muted py-15'>Loading feedback...</div>}

          {!loading && error && (
            <div className='alert alert-danger d-flex align-items-center p-4'>
              <span>{error.message}</span>
            </div>
          )}

          {/* A notification outlives the record it points at, so a missing
              feedback is an expected state rather than a failure. */}
          {!loading && !error && !feedback && (
            <div className='text-center py-15'>
              <div className='text-gray-700 fw-semibold fs-5 mb-2'>
                This feedback is no longer available
              </div>
              <div className='text-muted fs-7'>
                {message || 'It may have been deleted since the notification was sent.'}
              </div>
            </div>
          )}

          {!loading && feedback && (
            <>
              <div className='row mb-7'>
                <label className='col-lg-3 fw-bold text-muted'>Name</label>
                <div className='col-lg-9'>
                  <span className='fw-bold fs-6 text-gray-800'>{feedback.name || '—'}</span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-3 fw-bold text-muted'>Email</label>
                <div className='col-lg-9'>
                  {feedback.email ? (
                    <a href={`mailto:${feedback.email}`} className='fw-semibold fs-6 text-primary'>
                      {feedback.email}
                    </a>
                  ) : (
                    <span className='fw-semibold fs-6 text-gray-800'>—</span>
                  )}
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-3 fw-bold text-muted'>Subscription</label>
                <div className='col-lg-9'>
                  {feedback.subscription ? (
                    <span className='badge badge-light-primary'>{feedback.subscription}</span>
                  ) : (
                    <span className='fw-semibold fs-6 text-gray-800'>—</span>
                  )}
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-3 fw-bold text-muted'>Submitted</label>
                <div className='col-lg-9'>
                  <span className='fw-semibold fs-6 text-gray-800'>
                    {moment(feedback.createdAt).format('LL')} at{' '}
                    {moment(feedback.createdAt).format('h:mm A')}
                  </span>
                </div>
              </div>

              <div className='row mb-7'>
                <label className='col-lg-3 fw-bold text-muted'>Feedback</label>
                <div className='col-lg-9'>
                  <span
                    className='fw-semibold fs-6 text-gray-800'
                    style={{whiteSpace: 'pre-wrap'}}
                  >
                    {feedback.description || '—'}
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default FeedbackDetailsPage
